import 'react-app-polyfill/ie11';
import './ie11_polyfills';
import {app} from 'hyperapp';
import {div, img, span, a, strong, br} from '@hyperapp/html';
import './index.scss';
import Lightbox from './lightbox';
import {isValidUrl, findEmpFromHash, nl2br, hasBio} from './parsingTools';

if (!Number.parseInt)
    Number.parseInt = window.parseInt;

const transparent_pixel = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
const baseBranchAPIroute = '/wp-json/wfg/v1';
const endpoints = {
    locations: 'locations',
    'about-us': 'departments'
};

const initial_state = () => ({
    Employees: [],
    lightbox: null
});

const actions = {
    dispatch(event) {
        return (state, {dispatch}) => {
            switch (event.type) {
                case 'set_branch_data':
                    state.Employees = event.Employees;
                    return {...state};
                case 'open_bio_lightbox':
                    const lightbox_div = document.createElement('div');
                    lightbox_div.setAttribute('id', 'lightbox');
                    const lightbox = {
                        actions: app(
                            {
                                ...event.info,
                                dispatch
                            },
                            {
                                img(src) {
                                    return lightbox_state => ({...lightbox_state, imageMed: src});
                                }
                            },
                            Lightbox,
                            lightbox_div
                        ),
                        info: event.info
                    };
                    document.body.appendChild(lightbox_div);
                    return {...state, lightbox};
                case 'close_bio_lightbox':
                    document.getElementById('lightbox').remove();
                    state.lightbox = null;
                    return {...state};
                default:
                    console.error('unknown event:', event);
                    break;
            }
            return state;
        }
    }
};

const openBioLightbox = (emp, index) => ({
    type: 'open_bio_lightbox',
    info: {
        firstName: emp['First Name'],
        lastName: emp['Last Name'],
        title: emp.Title,
        imageMed: emp.img && emp.img.med ? emp.img.med : transparent_pixel,
        bio: emp.Bio,
        index
    }
});

const StaffInfo = (emp, dispatch, index) => {
    /**
     * Support for custom schemas/fields in employee records
     * Custom fields will be shown alphabetically just above the read more link for their bio
     * URL detection occurs to support hyperlinks as custom fields
     */
    const ordinal_keys = [
        'Branch',
        'First Name',
        'Last Name',
        'Title',
        'Email',
        'Phone',
        'Mobile',
        'Fax',
        'Bio',
        'Department'
    ];
    const employee_schema = Object.keys(emp).sort();
    const contact_schema = {'Phone': 'Direct', 'Mobile': 'Cell', 'Fax': 'Fax'};

    return [
        strong(`${emp['First Name']} ${emp['Last Name']}`),
        br(),
        strong({
            oncreate(el) {
                el.innerHTML = emp.Title.reduce((a, c) => {
                    return `${a}${c}`;
                }, "");
            }
        }),
        br(),
        a({href: `mailto:${emp.Email}`, className: 'email-address'}, emp.Email),
        br(),
        Object.keys(contact_schema).filter(key => {
            return !!emp[key]
        }).map(key => {
            return [`${contact_schema[key]}: ${emp[key]}`, br()];
        }),
        employee_schema.filter(key => {
            return ordinal_keys.indexOf(key) === -1 && key !== 'img' && !!emp[key];
        }).map(key => {
            if (!isValidUrl(emp[key])) return [span(`${key}: `), emp[key]];
            return [span(`${key}: `), a({href: `http://${emp[key]}`}, emp[key])];
        }),
        hasBio(emp.Bio) && a({
            style: {cursor: 'pointer'},
            onclick: () => {
                dispatch(openBioLightbox(emp, index))
            }
        }, `Read more about ${emp['First Name']}`)
    ];
};

const View = (state, {dispatch}) => {
    const {Employees} = state;

    if (process.env.NODE_ENV !== 'production')
        window.app = {state, dispatch};

    return div({id: 'employees', className: !Employees.length ? '' : 'loaded'}, [
        div({className: 'staffFlexbox'},
            Employees.map((emp, index) => {
                return div({className: 'staffMember'}, [
                    div({className: 'staffPhoto'}, [
                        hasBio(emp.Bio)
                            ? img({
                                style: {cursor: 'pointer'},
                                src: emp.img && emp.img.sm ? emp.img.sm : transparent_pixel,
                                onclick: () => dispatch(openBioLightbox(emp, index))
                            })
                            : img({src: emp.img && emp.img.sm ? emp.img.sm : transparent_pixel})
                    ]),
                    div({className: 'staffinfo'}, StaffInfo(emp, dispatch, index))
                ])
            })
        )
    ])
};

const [baseLocation, subLocation] = document.location.pathname.split("/").filter(i => i !== '');

const ReplacementView = document.createElement('div');

const {dispatch} = app(initial_state(), actions, View, ReplacementView);

const isCommercialPage = !subLocation && baseLocation === 'commercial';
const endpoint = isCommercialPage
    ? `${baseBranchAPIroute}/locations/commercial`
    : `${baseBranchAPIroute}/${endpoints[baseLocation]}/${subLocation}`;

if ((baseLocation && subLocation) || isCommercialPage) {
    fetch(endpoint)
        .then(r => Promise.all([r.ok, r.json()]))
        .then(([ok, branchData]) => {
            if (!ok)
                throw branchData;

            const container = document.getElementById('employees');
            container.parentNode.replaceChild(ReplacementView, document.getElementById('employees'));
            return branchData.Employees;
        })
        .then(Employees => {
            const parsedEmployees = Employees.map(emp => {
                return {...emp, Title: nl2br(emp.Title), Bio: nl2br(emp.Bio)};
            });
            dispatch({type: 'set_branch_data', Employees: parsedEmployees});
            return parsedEmployees;
        })
        .then(Employees => {
            const {result, index} = findEmpFromHash(document.location.hash, Employees);
            if (!!result && hasBio(result.Bio)) {
                dispatch(openBioLightbox(result, index))
            }
        })
        .catch(console.error);
}

export {
    View,
    actions,
    initial_state
}